import React, {useEffect} from 'react'
import useList from '../../../../hooks/useList'
import VariantFilter from './VariantFilter'
import Checkbox from '../../../../shared/Checkbox'
import CircleColor from '../../../../shared/CircleColor'

const VariantTable = (props) => {
    const {variants, attributes, onChange, defaultSelectedVariants} = props

    const {
        onFilterList: handleFilterVariants,
        filteredList: filteredVariants,
        selected: selectedVariants,
        onUpdateSelected,
        onAddItemToSelected,
        onRemoveItemFromSelected,
        isSelectedAll,
        selectAll,
        unSelectAll,
        isSelected,
    } = useList({
        initialList: variants.map((v) => ({...v, id: v._id})),
        defaultSelected: defaultSelectedVariants.map((v) => ({...v, id: v._id})),
    })

    useEffect(() => {
        onChange?.(selectedVariants)
    }, [selectedVariants])

    if (!variants.length) return null

    const handleSelectAllVariant = () => {
        if (isSelectedAll) {
            unSelectAll()
        } else {
            selectAll()
        }
    }

    const handleSelectVariant = (variant) => {
        const {id} = variant
        if (isSelected(id)) {
            onRemoveItemFromSelected(id)
        } else {
            onAddItemToSelected(variant)
        }
    }

    const handleVariantsFilterChange = (variantFilter) => {
        const getVariantMatchFilter = (variant) => {
            return Object.entries(variantFilter).every(([attrName, values]) => {
                const attribute = variant.attributes.find((attr) => attr.type === attrName)
                if (!attribute) return false

                return values.includes(attribute.value_code)
            })
        }

        const filter = handleFilterVariants(getVariantMatchFilter)

        filter()
        const updatedSelectedVariants = selectedVariants.filter(getVariantMatchFilter)
        onUpdateSelected(updatedSelectedVariants)
    }

    return (
        <div className="VariantTable">
            {/*<div className="table-responsive">*/}
            <table className="table">
                <thead className="thead-light">
                    <tr>
                        <th className="text-left CheckboxCell">
                            {/*<div className="custom-control custom-checkbox">*/}
                            <Checkbox
                                checked={isSelectedAll}
                                onChange={handleSelectAllVariant}
                                indeterminate={selectedVariants.length > 0 && !isSelectedAll}
                            />
                            {/*</div>*/}
                        </th>
                        {!!attributes.length &&
                            attributes.map((attribute, index) => {
                                return (
                                    <th key={`attribute_thead_${index}`} className="text-capitalize">
                                        {attribute.name}
                                    </th>
                                )
                            })}
                        <th className="text-right table-col-12 BaseCodeCol">Base Cost</th>
                    </tr>
                </thead>

                <tbody>
                    <VariantFilter attributes={attributes} onChange={handleVariantsFilterChange} />
                    {!!filteredVariants.length ? (
                        filteredVariants.map((variant, index) => {
                            const {sku, attributes, base_cost, disabled, id} = variant
                            return (
                                <tr key={`variant_${index}`}>
                                    <td className="text-left CheckboxCell">
                                        <Checkbox
                                            checked={isSelected(id)}
                                            onChange={() => handleSelectVariant(variant)}
                                            disabled={disabled}
                                        />
                                    </td>
                                    {!!attributes?.length &&
                                        attributes.map((attribute) => {
                                            const {type, value_text, value_code, link_color} = attribute
                                            return (
                                                <td key={`${type}_${sku}`}>
                                                    <label className="d-flex align-items-center mb-0 pt-1">
                                                        {type === 'color' && (
                                                            <CircleColor
                                                                color={value_code}
                                                                bgUrl={link_color}
                                                                className={'me-2'}
                                                            />
                                                        )}
                                                        {value_text}
                                                    </label>
                                                </td>
                                            )
                                        })}
                                    <td className="text-right">{base_cost ? `$${base_cost}` : '-'}</td>
                                </tr>
                            )
                        })
                    ) : (
                        <tr className="text-center">
                            <td className="text-muted fs-14" colSpan={2 + attributes.length}>
                                No result!
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            {/*</div>*/}
        </div>
    )
}

export default VariantTable
